import { render, staticRenderFns } from "./postsalelistOEM.vue?vue&type=template&id=8d9099ea&"
import script from "./postsalelistOEM.vue?vue&type=script&lang=ts&"
export * from "./postsalelistOEM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports